module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_18_F.5b14bb2e.mp3";